import React from "react"

/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-07-01 08:56:13
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-01 08:58:19
 */
export default class Template extends React.Component {

    render() {
        return (
            <div className={'usercenter-tab-contnt'}>
                <div className={'usercenter-tab-title-panel'}>
                    <div className={'usercenter-tab-title-panel-text'}>
                        {this.props.title}
                    </div>
                </div>
                {this.props.children}
            </div>
        )
    }
}